// extracted by mini-css-extract-plugin
module.exports = {"reporting-overview__no-data":"ReportingOverview_reporting-overview__no-data__3OCMQ"};